var m1 = "/static/91e82d02a7796605.png";

export { m1 as default };
//# sourceMappingURL=m_1.png.js.map
